import { Injectable } from '@angular/core';
import { MessagingService } from '@app/services/messaging.service';
import { UISettings } from '../neo-table/neo-table-value';

@Injectable({
  providedIn: 'root'
})
export class NeoCardListService {

  constructor(private messagingService: MessagingService) { }

  getUISettings(cardListName: string): UISettings {
    let uiSetting = {} as UISettings;
    try {
      uiSetting = JSON.parse(localStorage.getItem('card_list_settings_' + cardListName) || '{}') as UISettings;
    } catch (err) {
      this.messagingService.showError((err as Error).message);
    }
    return uiSetting;
  }

  setUISettings(cardListName: string, uiSettings: UISettings): void {
    try {
      localStorage.setItem('card_list_settings_' + cardListName, JSON.stringify(uiSettings || {}));
    } catch (err) {
      this.messagingService.showError((err as Error).message);
    }
  }
}
